import { render } from "./PlayerMessageList.vue?vue&type=template&id=6900c985"
import script from "./PlayerMessageList.vue?vue&type=script&lang=js"
export * from "./PlayerMessageList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__